import { render } from "./InscriptionView.vue?vue&type=template&id=77f23e60&scoped=true"
import script from "./InscriptionView.vue?vue&type=script&lang=js"
export * from "./InscriptionView.vue?vue&type=script&lang=js"

import "./InscriptionView.vue?vue&type=style&index=0&id=77f23e60&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-77f23e60"]])

export default __exports__